const nestedDialogs = "--nested-dialogs";
export {
  nestedDialogs
};
//# sourceMappingURL=DialogPopupCssVars.js.map
